import React from 'react'
import { FaTimes } from "react-icons/fa";

const ModalClose = props => (
    <button
        type='button'
        className="modal-empty-button modal-close"
        value="close"
        onClick={props.toggleModal}
    >
        <FaTimes size={"2em"} />
        <span className="usa-sr-only">Close modal</span>
    </button>
)

export default ModalClose